// Home report requests can take long enough for the filters to change while
// they are in flight. A response requested under an older filters.changesId
// must be dropped, otherwise it overwrites the data for the current filters.
const hasFiltersChanged = (store, userClientId, changesId) =>
    store.getState().clients?.[userClientId]?.filters?.changesId !== changesId;

export default hasFiltersChanged;
